import styled from "styled-components";
import media from "styled-media-query";

export const WrapperProposal = styled.div`
  height: 300px;
  overflow: hidden;
  border: 1px solid #ddd;
  padding: 15px;
  margin-bottom: 10px;
  background: #ffffff;
  width: 80%;

  &::-webkit-scrollbar {
    border-radius: 10px;
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c8c8c8;
    border-radius: 10px;
  }
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #333;
  line-height: 1.5;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;

  ${media.greaterThan("medium")`
    font-size: 20px;
  `}
`;

export const Text = styled.div`
  text-align: justify;
  font-size: 14px;
  font-weight: normal;
  color: #333;
  line-height: 1.5;
  margin-bottom: 10px;

  ${media.greaterThan("medium")`
    font-size: 16px;
  `}
`;

export const Ol = styled.ol`
  padding-left: 20px;
  text-align: justify;
  font-size: 14px;
  font-weight: normal;
  color: #333;
  line-height: 1.5;

  ${media.greaterThan("medium")`
    font-size: 16px;
  `}
`;
